import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const DraggableDayCard = ({ id, day }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

 return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex flex-col items-center justify-center p-4 bg-white border border-gray-100 rounded-2xl shadow-sm hover:shadow-md transition-all select-none"
    >
      <div className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1">
        Day
      </div>

      <div className="text-2xl font-bold text-gray-900 mb-2">
        {day.displayDay}
      </div>

      {/* DRAG HANDLE */}
      <div
        {...attributes}
        {...listeners}
        style={{ touchAction: "none" }}
        className="w-full flex items-center justify-center gap-1 py-2 rounded-lg bg-gray-50 text-gray-500 text-xs font-semibold cursor-grab active:cursor-grabbing active:scale-[0.98] transition"
      >
        <span className="text-base">⋮⋮</span>
        <span>Drag</span>
      </div>
    </div>
  );
};

export default DraggableDayCard;